import {injectable} from "inversify";
import "@/extensions/date.extensions";
import {ApiService} from "@/services/apiService";
import {IDocumentService} from "@/injection/interfaces";
import {AxiosError, AxiosResponse} from "axios";
import {Document, IAddDocumentsRequest, IDocument} from "@/types/entities/document";
import {SucceededOrNotResponse} from "@/types/responses";

@injectable()
export class DocumentService extends ApiService implements IDocumentService {
  public async addDocuments(request: IAddDocumentsRequest): Promise<IDocument[]> {
    const response = await this._httpClient
      .post<IAddDocumentsRequest, AxiosResponse<IDocument[]>>(
        `${process.env.VUE_APP_API_BASE_URL}/api/documents`, request, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
      .catch(function (error: AxiosError): AxiosResponse<IDocument[]> {
        return error.response as AxiosResponse<IDocument[]>
      });
    return response.data
  }

  public async updateDocument(document: Document): Promise<Document> {
    const response = await this._httpClient.put<
      Document,
      AxiosResponse<Document>
    >(`${process.env.VUE_APP_API_BASE_URL}/api/documents/${document.id}`, document, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .catch(function (error: AxiosError): AxiosResponse<SucceededOrNotResponse> {
        return error.response as AxiosResponse<SucceededOrNotResponse>;
      });
    return response.data as Document;
  }

  public async getAllDocuments(sharedPolicy?: number): Promise<Document[]> {
    const route = `${process.env.VUE_APP_API_BASE_URL}/api/documents${sharedPolicy != undefined ? '?policy=' + sharedPolicy : ''}`;
    const response = await this._httpClient.get<AxiosResponse<Document[]>>(route)
      .catch(function (error: AxiosError): AxiosResponse<Document[]> {
        return error.response as AxiosResponse<Document[]>;
      });
    return response.data as Document[];
  }

  public async getDocument(id: string): Promise<Document> {
    const route = `${process.env.VUE_APP_API_BASE_URL}/api/documents/${id}`;
    const response = await this._httpClient.get<AxiosResponse<Document[]>>(route)
      .catch(function (error: AxiosError): AxiosResponse<Document[]> {
        return error.response as AxiosResponse<Document[]>;
      });

    return response.data as Document;
  }

  public async deleteDocument(id: string): Promise<SucceededOrNotResponse> {
    const response = await this._httpClient.delete<
      string,
      AxiosResponse<SucceededOrNotResponse>
    >(`${process.env.VUE_APP_API_BASE_URL}/api/documents/${id}`)
      .catch(function (error: AxiosError): AxiosResponse<SucceededOrNotResponse> {
        return error.response as AxiosResponse<SucceededOrNotResponse>;
      });
    return response.data;
  }
}